import { render } from "./OrderStatusPage.vue?vue&type=template&id=54f9d67f&scoped=true"
import script from "./OrderStatusPage.vue?vue&type=script&lang=js"
export * from "./OrderStatusPage.vue?vue&type=script&lang=js"

import "./OrderStatusPage.vue?vue&type=style&index=0&id=54f9d67f&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f9d67f"]])

export default __exports__